import React from "react";
import Main from "../components/main";
import ESafetyComponent from "../components/esafety";

export default function ESafety() {
  return (
    <Main>
      <ESafetyComponent/>
    </Main>
  );
}